export default function ActivityEventsChart() {
  return (
    <div className="rounded-xl border bg-white p-5 shadow-sm">
      <h2 className="text-lg font-semibold text-gray-800">By Event Type</h2>

      <div className="mt-4 flex h-40 items-center justify-center rounded-xl border text-gray-400">
        Horizontal Bar Chart Placeholder
      </div>
    </div>
  );
}
